import React, { Component, cloneElement } from 'react';
import { withReactlytics } from '@americanexpress/reactlytics';

class AnalyticsClick extends Component {
  constructor(props) {
    super(props);
    this.state = {};
    this.click = this.click.bind(this);
  }

  click() {
    // Details of Reactlytics track() and what it expects
    // PARAM    TYPE    DESCRIPTION
    // type:    string  Type of event that is being sent.
    // element: string  Name of element that the event is sent from (required).
    // detail:  string  Extra details if element isn’t unique enough.
    // meta:    object  Granular data pertaining to the event.
    // See https://one-dev.aexp.com/one-app/developer-guide/how-to/analytics.html

    const element = this?.props?.element || 'not defined';
    const benefitNameTag = this?.props?.benefitNameTag || 'not defined';
    // eslint-disable-next-line no-unsafe-optional-chaining -- needed
    const { track } = this?.props?.analytics;
    track({
      event: {
        type: 'click',
        element,
        meta: { benefitname: benefitNameTag },
        identifier: 'axp-benefits-view-all',
        details: benefitNameTag,
      },
    });
    if (typeof this?.props?.onClick === 'function') {
      this.props.onClick();
    }
  }

  /**
   * Take the child JSX elements from this.props.children, use cloneElement to copy it,
   * and then add a click handler to it: this.click().
  */
  render() {
    // console.log('this.props.children: ', this.props.children)
    return (
      <>
        {cloneElement(this.props.children, { onClick: this.click })}
      </>
    );
  }
}

export default withReactlytics()(AnalyticsClick);
